























import Vue, {VueConstructor} from 'vue'
import User from '@/models/Users/User'
import UiSwitch from '@/components/Ui/Switch/switch.vue'
import Newsfeed from '@/models/Newsfeed/Newsfeed'

export default (Vue as VueConstructor<Vue & {
  $copyText: (text: string) => void
}>).extend({
  components: {
    UiSwitch
  },
  data () {
    return {
      newsfeedInfo: [] as Newsfeed[]
    }
  },
  computed: {
    user (): User | false {
      return this.$store.state.user.user;
    },
    userNewsfeed (): {[key: string]: boolean} | false {
      return this.user && this.user.getNewsfeed() || false
    }
  },
  methods: {
    async loadNewsfeedInfo () {
      try {
        const resp = await this.$store.dispatch('newsfeeds/newsfeedInfo')
        this.newsfeedInfo = resp
      } catch (error) {
        // @ts-ignore
        this.$message.error(this.$t('news.can_not_load_newsfeed'))
      }
    },
    isActive (newsfeed: Newsfeed): boolean {
      if (!this.userNewsfeed && newsfeed.getForAll()) {
        return true
      } else if (this.userNewsfeed) {
        return !!this.userNewsfeed[newsfeed.id]
      }
      return false
    },
    async onFeedClick (newsfeed: Newsfeed) {
      let currentState = false
      if (!this.userNewsfeed) {
        currentState = true
      } else {
        currentState = !!this.userNewsfeed[newsfeed.id]
      }
      if (currentState) {
        // @ts-ignore
        this.$confirm(`${this.$t('news.sure_disable_notifications_in')} ${newsfeed.getTitle()}`, this.$t('labels.attention'), {
          confirmButtonText: this.$t('labels.unsubscribe'),
          cancelButtonText: this.$t('labels.cancel'),
          type: 'warning'
        }).then(() => {
          this.setStatus(newsfeed.id, !currentState)
        }).catch(() => {})
      } else {
        this.setStatus(newsfeed.id, !currentState)
      }
    },
    async setStatus (feedId: string, status: boolean) {
      try {
        await this.$store.dispatch('newsfeeds/newsfeedStatus', {newsfeed_id: feedId, status})
        await this.$store.dispatch('user/loadUser', true)
        // @ts-ignore
        this.$message.success(this.$t('news.subscription_updated'))
      } catch (error) {
        // @ts-ignore
        this.$message.error(this.$t('news.can_not_update_subscription'))
      }
    },
    // @ts-ignore
    async copyText (text: string, target = this.$t('news.code_copyied')) {
      try {
        this.$copyText(text);
        // @ts-ignore
        this.$message.success(`${target} ${this.$t('news.to_buffer')}`)
      } catch (error) {
        // @ts-ignore
        this.$message.warning(this.$t('messeger.can_not_copy_code'))
      }
    }
  },
  async mounted () {
    await this.loadNewsfeedInfo()
  }
})
